import { render, staticRenderFns } from "./TolAltButton.vue?vue&type=template&id=485b5c90&scoped=true&"
import script from "./TolAltButton.vue?vue&type=script&lang=js&"
export * from "./TolAltButton.vue?vue&type=script&lang=js&"
import style0 from "./TolAltButton.vue?vue&type=style&index=0&id=485b5c90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485b5c90",
  null
  
)

export default component.exports